export default "Tournament!\n"